/** @module Classes */ /** typedoc */
import {
    PlanFrequencyEnum,
    SubscriptionStatusEnum,
    SubscriptionMigrationTimingEnum,
    SubscriptionMigrationTypeEnum,
    SubscriptionServiceOfferEnum,
} from '../../enums';
import { InvoicePreview } from './InvoicePreview';
import { keys } from 'ts-transformer-keys';

export class Plan {
    public code: string = null;
    public frequency: PlanFrequencyEnum = null;
    public isBasePlan: boolean = null;
}

export class SubscriptionProduct {
    public code: string = null;
    public currentQuantity: number = null;
    public isUnlimited: boolean = null;
    public maxQuantity: number = null;
}

export class Subscription extends Plan {
    public serviceOffer: SubscriptionServiceOfferEnum = null;
    public status: SubscriptionStatusEnum = null;
    public segment: string = null;
    /**
     * If Set it means the current plan will not be renewed and will end at this date.
     * Warning : Cancel subscription on samples will have endDate but no Next Plan
     */
    public endDate: string = null;
    /**
     * Date of renewal for an ongoing subscription, or when the next subscription will start
     */
    public renewalDate: string = null;
    public products: SubscriptionProduct[] = null;
}

export class SubscriptionNext extends Plan {
    public segment: string = null;
    public startDate: string = null;
}

export class SubscriptionPrepared {
    public planCode: string = null;
    public planSegment: string = null;
    public serviceOffer: SubscriptionServiceOfferEnum = null;
    public migrationDate: string = null;
    public migrationType: SubscriptionMigrationTypeEnum = null;
    public migrationTiming: SubscriptionMigrationTimingEnum = null;
    public invoicePreview: InvoicePreview = null;
    public token: string = null;
}

export const keysOfSubscription: Array<keyof Subscription> = keys<Subscription>();
export const keysOfSubscriptionNext: Array<keyof SubscriptionNext> = keys<SubscriptionNext>();
export const keysOfSubscriptionPrepared: Array<keyof SubscriptionPrepared> = keys<SubscriptionPrepared>();
